export function StepsForms() {
    const $CaseEvaluationForms = $(".case-evaluation-block");
    $CaseEvaluationForms.each(function () {
        StepsForm($(this));
    });
}
function StepsForm(block) {
    const $block = block;
    const $form = $block.find("form");
    const $formBlock = $block.find(".case-evaluation-form");
    const $closeSuccessBtn = $block.find(".button-close");
    const $submitBtn = $form.find("button");
    const $prevBtn = $block.find(".button-nav.prev");
    const $nextBtn = $block.find(".button-nav.next");
    const $steps = $block.find(".step");
    const stepsNavigation = $block.find(".steps-navigation");
    const $stepsMaxBlock = $block.find(".steps-max");
    const $stepCurrentBlock = $block.find(".step-current");
    const $inputs = $form.find("input, textarea, select");
    const WIN = $(window);
    let isMobile = false;
    const point = 1200;
    let current = 0;
    const max = $steps.length - 1;
    let activeStep;
    let currentStepInputs;
    let windowWidth;

    setInitialValues();

    function setInitialValues() {
        $stepsMaxBlock.text(max + 1);
        // $submitBtn.prop("disabled", true);
        getParamsWindow();
        setStylesPopoup();
        setActiveStep();
        controllForm();
        setEvents();
    }
    function setStylesPopoup() {
        if (!$block.parents(".popup").length) return;
        if (isMobile) {
            $block.addClass("fixed");
            $formBlock.css("height", `calc(100vh - ${$(".case-evaluation-title").outerHeight()}px)`);
        } else {
            $formBlock.removeAttr("style");
            $block.removeClass("fixed");
        }
    }
    function getParamsWindow() {
        windowWidth = WIN.width();
        isMobile = (windowWidth < point) ? true : false;
    }
    function setEvents() {
        WIN.on("resize", function () {
            getParamsWindow();
            setStylesPopoup();
            setPositionNavagation();
        });
        $inputs.on("change, input", function () {
            controllForm();
        });
        $("select").on("change", function () {
            controllForm();
        });
        $nextBtn.on("click", function () {
            current += 1;
            setActiveStep();
            controllForm();
        });
        $prevBtn.on("click", function () {
            current -= 1;
            setActiveStep();
            controllForm();
        });
        $submitBtn.on("click", function (e) {
            e.preventDefault();
            $.ajax({
                type: "post",
                url: ajax.url,
                data: {
                    action: "eval_form_validation",
                    data: $form.serialize(),
                    _ajax_nonce: ajax.evaluation_form_nonce_token
                },
                beforeSend: function () {
                    $form.find(".error-msg").text("");
                    $form.find("input, select").removeClass("field-invalid");
                    $form.find(".error-field-msg").remove();
                },
                success: function (msg) {
                    if (msg.status === true) {
                        submitForm();
                    } else {
                        const errors = msg.errors;
                        for (const key in errors) {
                            const field = $form.find('input[name="' + errors[key].name + '"], select[name="' + errors[key].name + '"]');
                            if (field.length) {
                                field.addClass("field-invalid");
                                field.after('<span class="error-field-msg">' + errors[key].error + '</span>');
                            }
                        }
                        $form.find(".error-msg").text(msg.error_msg);
                    }
                }
            });
        });
        $closeSuccessBtn.on("click", function () {
            $block.removeClass("is-success");
            $form.trigger("reset");
            current = 0;
            setActiveStep();
            controllForm();
        });

    }
    function submitForm() {
        $block.addClass("is-success");
    }
    function setPositionNavagation() {

        if (current === max && !isMobile) {
            let width = $submitBtn.innerWidth() + 16;
            stepsNavigation.css("padding-right", width + "px");
        } else {
            stepsNavigation.removeAttr("style");
        }
    }
    function setActiveStep() {
        activeStep = $steps.eq(current);
        currentStepInputs = activeStep.find("input, textarea, select");
        $steps.removeClass("active");
        activeStep.addClass("active");
        $stepCurrentBlock.text(current + 1);
        setPositionNavagation();
    }
    function controllForm() {
        let valid = validate(currentStepInputs);
        if (!valid) {
            $nextBtn.prop("disabled", true);
            // $submitBtn.prop("disabled", true);
        }
        if (valid && current === max) {
            $nextBtn.prop("disabled", true);
            // $submitBtn.prop("disabled", false);
        }
        if (valid && current !== max) $nextBtn.prop("disabled", false);
        if (current === 0) {
            $prevBtn.prop("disabled", true);
        } else {
            $prevBtn.prop("disabled", false);
        }
    }
    function validate(inputs) {
        const dataForm = $form.serializeArray();
        if (!dataForm.length) return false;
        let arr = [];
        inputs.each(function () {
            arr.push($(this).attr("name"));
        });
        const names = [...new Set(arr)]; //массив со всеми name input-ов степа
        let dataFormObj = dataForm.reduce(function (target, data_form) {
            target[data_form.name] = data_form.value;
            return target;
        }, {});
        return names.every(name => dataFormObj[name] && dataFormObj[name].length !== 0);
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/StepsForms.js